import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { responseError } from '../../helpers/responseHandler'
import {
  useEditCompanyProfileMutation,
  useEditProfileMutation,
  useGetCompanyProfileQuery,
  useGetProfileQuery,
} from '../../redux/services/ProfileService'
import { convertToFormData, sweetAlert } from '../../utils'
import LoadingButtonWithForm from '../LoadingButtonWithForm'
import GlobalLoading from '../GlobalLoading'
import PhoneInput from 'react-phone-input-2'
import AlertCreateModal from '../../pages/DriverManagementPage/AlertModal'
import AlertCompanyModal from './AlertCompanyModal'

const UpdateCompany = () => {
  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()
  const [isAlert, setIsAlert] = React.useState(false)
  const [isShow, setIsShow] = React.useState(false)
  const [isEditMode, setIsEditMode] = React.useState(false)

  const [editRequest, { isLoading: editLoading }] = useEditCompanyProfileMutation()

  const { data: data2, isLoading, isFetching, refetch } = useGetCompanyProfileQuery()
  const isEdit = data2?.response?.data

  const handleAdd = data => {
    setIsAlert({ ...data })
    setIsShow(true)
  }

  const onSubmit = async data => {
    Object.keys(data)?.forEach(key => {
      if (data[key] === null || data[key] === undefined) {
        delete data[key]
      }
    })
    const newForm = convertToFormData(data)

    console.log('newForm', data)
    await editRequest(newForm)
      .unwrap()
      .then(res => {
        if (res?.status) {
          sweetAlert(res?.message, 'success')
        }
      })
      .catch(err => {
        responseError(err)
      })
  }
  return (
    <>
      {isLoading || isFetching ? (
        <GlobalLoading />
      ) : (
        <>
          <div className='row'>
            <div className='col-xl-12'>
              <div className=''>
                <div className='p-5' style={{ height: 500, overflowY: 'auto' }}>
                  <div className='mb-4 main-content-label'>Company Information</div>
                  <Form
                    onSubmit={handleSubmit(onSubmit)}
                    className='form-horizontal'
                    id='company-status'
                  >
                    {/* <div className="mb-4 main-content-label">Name</div> */}
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            COMPANY NAME &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='company_name'
                            control={control}
                            defaultValue={isEdit?.company_name || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type='text'
                                placeholder='Enter Company Name'
                                isInvalid={errors.company_name}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            DOING BUSINESS AS (DBA) NAME &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='dba_name'
                            control={control}
                            defaultValue={isEdit?.dba_name || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type='text'
                                placeholder='Enter DBA Name'
                                isInvalid={errors.dba_name}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            MC NUMBER &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='mc_number'
                            control={control}
                            defaultValue={isEdit?.mc_number || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type='number'
                                placeholder='Enter MC Number'
                                isInvalid={errors.mc_number}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            DOT NUMBER &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='dot_number'
                            control={control}
                            defaultValue={isEdit?.dot_number || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type='number'
                                placeholder='Enter DOT Number'
                                isInvalid={errors.dot_number}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            EIN (EMPLOYER IDENTIFICATION NO) &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='ein_number'
                            control={control}
                            defaultValue={isEdit?.ein_number || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type='TEXT'
                                placeholder='Enter EIN'
                                isInvalid={errors.ein_number}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            EMAIL ADDRESS &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='company_email'
                            control={control}
                            defaultValue={isEdit?.company_email || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type='text'
                                placeholder='Enter Company Email'
                                isInvalid={errors.company_email}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            PHONE NUMBER &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='company_phone'
                            control={control}
                            defaultValue={isEdit?.company_phone || ''}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <PhoneInput
                                {...field}
                                country={'us'} // Default country
                                disabled={!isEditMode}
                                inputProps={{
                                  name: 'company_phone',
                                  required: true,
                                  autoFocus: true,
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            W9 FORM UPLOAD &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='w9_form'
                            control={control}
                            defaultValue={''}
                            rules={{
                              required: false,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                onChange={e => field.onChange(e.target.files[0])}
                                type='file'
                                isInvalid={errors.w9_form}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                          {isEdit?.w9_form && (
                            <a href={isEdit?.w9_form_url} target='_blank'>
                              {isEdit?.w9_form}
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            PROOF OF AUTHORITY (FMCSA) UPLOAD &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='poa'
                            control={control}
                            defaultValue={''}
                            rules={{
                              required: false,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                onChange={e => field.onChange(e.target.files[0])}
                                type='file'
                                isInvalid={errors.poa}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                          {isEdit?.poa && (
                            <a href={isEdit?.poa_url} target='_blank'>
                              {isEdit?.poa}
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            CERTIFICATE OF INSURANCE &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='coi'
                            control={control}
                            defaultValue={''}
                            rules={{
                              required: false,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                onChange={e => field.onChange(e.target.files[0])}
                                type='file'
                                isInvalid={errors.coi}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                          {isEdit?.coi && (
                            <a href={isEdit?.coi_url} target='_blank'>
                              {isEdit?.coi}
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            SAFETY RATING &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='safety'
                            control={control}
                            defaultValue={''}
                            rules={{
                              required: false,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                onChange={e => field.onChange(e.target.files[0])}
                                type='file'
                                isInvalid={errors.safety}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                          {isEdit?.safety && (
                            <a href={isEdit?.safety_url} target='_blank'>
                              {isEdit?.safety}
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            BUSINESS LICENSE UPLOAD &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='business_license'
                            control={control}
                            defaultValue={''}
                            rules={{
                              required: false,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                onChange={e => field.onChange(e.target.files[0])}
                                type='file'
                                isInvalid={errors.business_license}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                          {isEdit?.business_license && (
                            <a href={isEdit?.business_license_url} target='_blank'>
                              {isEdit?.business_license}
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='form-group '>
                      <div className='row'>
                        <div className='col-md-2'>
                          <label className='form-label'>
                            Notes &nbsp;
                            <span
                              type='button'
                              onClick={() =>
                                handleAdd({
                                  expiry: 'new',
                                  id: 2,
                                  name: 'Driver’s License Information',
                                })
                              }
                            >
                              <i class='fa fa-plus-circle text-success' style={{ fontSize: 17 }} />
                            </span>
                          </label>
                        </div>
                        <div className='col-md-10'>
                          <Controller
                            name='notes'
                            control={control}
                            defaultValue={isEdit?.notes || ''}
                            rules={{
                              required: false,
                            }}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                as='textarea'
                                rows={4}
                                isInvalid={errors.notes}
                                disabled={!isEditMode}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
                <div className='card-footer d-flex justify-content-end'>
                  {isEditMode ? (
                    <>
                      <button
                        type='button'
                        className='btn ripple btn-light w-sm me-2'
                        onClick={() => {
                          reset(isEdit) // ✅ reset karega original values par
                          setIsEditMode(false) // ✅ disable mode wapas
                        }}
                      >
                        Cancel
                      </button>
                      <LoadingButtonWithForm
                        isLoading={editLoading}
                        name='Save'
                        form='company-status'
                      />
                    </>
                  ) : (
                    <button
                      type='button'
                      className='btn ripple btn-primary w-sm'
                      onClick={() => setIsEditMode(true)}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {isShow && isAlert && (
            <AlertCompanyModal
              show={isShow}
              handleClose={() => {
                setIsAlert(null)
                setIsShow(false)
              }}
              isEdit={isEdit}
            />
          )}
        </>
      )}
    </>
  )
}

export default UpdateCompany
